"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Type = exports.Utils = void 0;
var react_1 = __importDefault(require("react"));
var app_1 = __importDefault(require("../../../crud-simple/generic/app"));
var Type = __importStar(require("./type"));
exports.Type = Type;
var Utils = __importStar(require("./utils"));
exports.Utils = Utils;
var dataDef = function (urlPrefix, detailUrlPrefix) {
    if (detailUrlPrefix === void 0) { detailUrlPrefix = 'additional-properties'; }
    return ({
        urlPrefix: urlPrefix,
        detailUrlPrefix: detailUrlPrefix,
        displayType: {
            editType: 'update'
        },
        title: 'Simple',
        listConfig: {},
        width: { sm: 12, md: 12, lg: 12 },
        fields: [
            {
                name: 'type',
                label: 'Type',
                type: 'select',
                options: Utils.categories,
                render: function (x) { return (react_1["default"].createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    react_1["default"].createElement(Utils.IconFromCategory, { category: x.type.id }),
                    ' ',
                    react_1["default"].createElement("span", { style: { marginLeft: '10px' } }, x.label))); }
            },
            { name: 'label', label: 'Label', type: 'string', hide: { list: true } },
            { name: 'value', label: 'Value', type: 'string', render: Utils.valueRender }
        ]
    });
};
var AdditionalProperty = function (_a) {
    var DataInterface = _a.DataInterface, urlPrefix = _a.urlPrefix, detailUrlPrefix = _a.detailUrlPrefix;
    return (react_1["default"].createElement(app_1["default"], { dataDef: dataDef(urlPrefix, detailUrlPrefix), Data: DataInterface }));
};
exports["default"] = AdditionalProperty;
